export default "__VITE_ASSET__d77d5e58__"